import { styled } from 'linaria/react';

export const StyledList = styled.ul`
  display: flex;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 16px 0;
`;
